/**
 * [INPUT]: 依赖 Lucide 状态图标、Button 与可选重试动作
 * [OUTPUT]: 对外提供 LoadingState、EmptyState、ErrorState 与 OfflineNotice
 * [POS]: components 的反馈语言中心，确保等待、无结果、故障和离线状态一致且可恢复
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { CircleAlert, CloudOff, LoaderCircle, SearchX } from 'lucide-react'

import { Button } from './ui/button'

export function LoadingState({ label = '正在取回内容…' }: { label?: string }) {
  return (
    <div className="state">
      <LoaderCircle className="spin" aria-hidden="true" />
      <p>{label}</p>
    </div>
  )
}

export function EmptyState({
  title = '这里还没有内容',
  detail = '换个关键词或清除标签再试。',
}: {
  title?: string
  detail?: string
}) {
  return (
    <div className="state">
      <SearchX aria-hidden="true" />
      <h2>{title}</h2>
      <p>{detail}</p>
    </div>
  )
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const detail = error instanceof Error ? error.message : '发生了未知错误'
  return (
    <div className="state state-error">
      <CircleAlert aria-hidden="true" />
      <h2>内容暂时不可用</h2>
      <p>{detail}</p>
      {onRetry && <Button onClick={onRetry}>重新尝试</Button>}
    </div>
  )
}

export function OfflineNotice() {
  return (
    <div className="notice" role="status">
      <CloudOff size={17} aria-hidden="true" />
      当前离线，正在使用已保存内容。
    </div>
  )
}
